import { observable } from "mobx";

export default class SimplePortalSettings {
  id!: number;

  @observable
  value!: string;

  @observable
  key!: string;

  @observable
  active!: boolean;

  @observable
  variant?: "info" | "danger" | "warning";

  get disabled() {
    return !this.active;
  }

  static ValidationRules = {
    id: { required: true, number: true },
    value: { required: true },
    key: { required: true },
    active: { required: true },
  };
}
